import classes from './Highlights.module.scss';
import SkillsBlock from 'components/layout/SkillsBlock';

const Highlights = ()=> {
  return (
    <section className={`${classes.highlights} pg-page`} name="services" id="services">
      <div className='bg-image-container'>
        <img src={require('assets/images/bg-highlights.jpg')}  alt="Highlights BG" />
      </div>
      <div className="container">
        <div>          
          <SkillsBlock />
        </div>
      </div>
    </section>
  );
}

export default Highlights;